import { render, staticRenderFns } from "./MessageManagement.vue?vue&type=template&id=e0b0ec74&"
import script from "./MessageManagement.vue?vue&type=script&lang=js&"
export * from "./MessageManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports